import React from 'react';
import PropTypes from 'prop-types';
import { Empty } from 'antd'; // Import Empty
import './styles/MiniStats.css';
import { ReactComponent as StarLogo } from '../../images/star.svg';
import { ReactComponent as HappyFaceLogo } from '../../images/face-smile.svg'; // Assuming this represents positive reviews
import { ReactComponent as FeedbackLogo } from '../../images/diagram.svg'; // Assuming this represents total feedback
import { ReactComponent as SadFaceLogo } from '../../images/sad-face.svg'; // Example for negative reviews
import { ReactComponent as ChartBarLogo } from '../../images/chart-bar.svg'; // Example for mean categories
import { ReactComponent as ArrowUpLogo } from '../../images/arrow-up.svg'; // Example for needed stars

const Stat = ({ label, value, icon }) => { // Simplified props
  return (
    <div className='stat glass-box'> {/* Generic class */} 
      <div className='icon'>{icon}</div>
      <div className="label-content">
        <div className="label"><p>{label}</p></div>
        <div className="value"><p>{value !== null && value !== undefined ? value : 'N/A'}</p></div>
      </div>
    </div>
  );
};

// Update component to receive props: loading, error, data
const MiniStats = ({ loading, error, data }) => {

  if (loading) {
    return <div className="mini-stats-container loading">Loading stats...</div>;
  }

  if (error) {
    return <div className="mini-stats-container error">Error loading stats: {error}</div>;
  }

  if (!data) {
    // Use Ant Design Empty component
    return (
      <div className="mini-stats-container no-data">
        <Empty description="No overview stats available yet. They will populate as you use the platform." />
      </div>
    );
  }

  // Map data from props to Stat components
  const statsToDisplay = [
    { label: 'Average Rating', value: data.average_rating?.toFixed(1) || 'N/A', icon: <StarLogo /> },
    { label: 'Total Feedback', value: data.total_feedbacks ?? 'N/A', icon: <FeedbackLogo /> },
    { label: 'Positive Reviews', value: data.positive_reviews ?? 'N/A', icon: <HappyFaceLogo /> }, // 
    { label: 'Negative Reviews', value: data.negative_reviews ?? 'N/A', icon: <SadFaceLogo /> }, // Using SadFaceLogo for negative
    { label: 'Mean Categories', value: data.mean_categories?.toFixed(1) || 'N/A', icon: <ChartBarLogo /> }, // Using ChartBarLogo for mean categories
    { label: 'Needed 5★ for Next Step', value: data.needed_five_stars ?? 'N/A', icon: <ArrowUpLogo /> } // Using ArrowUpLogo for needed stars
  ];

  return (
    <div className="mini-stats-container">
      {statsToDisplay.map((stat, index) => (
        <Stat
          key={index} // Use index as key, or a more stable id if available
          label={stat.label}
          value={stat.value}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

// Add PropTypes for the new props
MiniStats.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  data: PropTypes.shape({
    average_rating: PropTypes.number,
    total_feedbacks: PropTypes.number,
    positive_reviews: PropTypes.number,
    negative_reviews: PropTypes.number,
    mean_categories: PropTypes.number,
    needed_five_stars: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // Can be number or 'N/A'
    // Add other expected fields from the overview endpoint if needed
  })
};

export default MiniStats;